import routes from './experiences.routes';

export const experiencesModule = {
    routes
};